import { useState } from 'react';
import Dropdown from './Dropdown';
import Hamburger from './Hamburger';

interface MobileProps {
  currentItem?: string;
  className?: string;
}

export default function Mobile({ currentItem, className }: MobileProps): JSX.Element {
  const [showDropdown, setShowDropdown] = useState(false);

  function openDropdown(): void {
    setShowDropdown(true);
  }

  function closeDropdown(): void {
    setShowDropdown(false);
  }
  return (
    <nav className={className}>
      <Hamburger className="hamburger" onClick={openDropdown} />
      {showDropdown ? <div className="overlay" /> : null}
      <Dropdown show={showDropdown} currentItem={currentItem} close={closeDropdown} />

      <style jsx>{`
        .overlay {
          opacity: 0.35;
          background-color: black;
          position: fixed;
          height: 100%;
          width: 100%;
          left: 0px;
          top: 0px;
          z-index: 5;
        }
      `}</style>
    </nav>
  );
}
